const stateWatchers=(() => {
	
	return{
		'locale.country':null,
		'locale.locale':null,
		'locale.state':null,
		'locale.language':null,
		'app.countries':null
	}


})();

export default stateWatchers;


// WEBPACK FOOTER //
// ./src/services/stateWatchers.js